  if (!customElements.get("cart-recommendations")) {
    class CartRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.preventReInit) return;

        if (!this._boundCartUpdate) {
          this._boundCartUpdate = (event) => {
            const productId = event?.detail?.data?.productId;
            this.loadRecommendations({ force: true, productId });
          };
          document.addEventListener('cart:update', this._boundCartUpdate);
        }

        this.loadRecommendations();
      }

      disconnectedCallback() {
        if (this._boundCartUpdate) {
          document.removeEventListener('cart:update', this._boundCartUpdate);
        }
      }

      loadRecommendations({ force = false, productId } = {}) {
        if (this.dataset.preventReInit) return;
        if (this._isLoading) return;
        if (!force && this.dataset.loaded === 'true') return;

        this._isLoading = true;
        const url = new URL(this.dataset.url, window.location.origin);
        if (productId) {
          url.searchParams.set('product_id', productId);
        }

        fetch(url.toString())
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const hasProducts = html.querySelector('.td-cart-recommendations__product, .td-recos-modal__item');
          const recommendations = html.querySelector('cart-recommendations');

          if (recommendations) {
            this.innerHTML = recommendations.innerHTML;
            this.dataset.url = url.toString();
            this.#bindAddToCart();
          }

          if (hasProducts && recommendations) {
            this.dataset.loaded = 'true';
            this.classList.add('cart-recommendations--loaded');
            this.style.display = '';
          } else {
            this.dataset.loaded = '';
            this.classList.remove('cart-recommendations--loaded');
            this.innerHTML = '';
            this.style.display = 'none';
          }
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this._isLoading = false;
        });
      }

      #bindAddToCart() {
        const buttons = this.querySelectorAll('.td-cart-recommendations__button[data-variant-id]');
        buttons.forEach((button) => {
          button.removeEventListener('click', this.#handleAddToCart); // clean if re-rendered
          button.addEventListener('click', this.#handleAddToCart);
        });
      }

      #handleAddToCart = (event) => {
        const button = event.currentTarget;
        if (!(button instanceof HTMLElement)) return;

        const variantId = button.dataset.variantId;
        const productId = button.dataset.productId;
        if (!variantId) return;

        button.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
              },
            ],
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: data,
                  data: {
                    productId,
                    variantId,
                    source: 'td-cart-recommendations',
                  },
                },
              })
            );
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            button.disabled = false;
          });
      };
    }

    customElements.define('cart-recommendations', CartRecommendations);
  }